<template>
    <div id="ag-grid-demo">
        <vs-popup title="Input Device Code" :active.sync="showPopUp"  type="filled">
            <div class="vx-col md:w-4/4 w-full mb-2">
                <p>Kondisi Device saat ini : </p>
            </div>
            <div class="flex flex-wrap items-center">
                <p>Status Provision : </p>
                <vs-chip class="my-2 ml-2" v-bind:color="statusColor">
                    {{statusText}}
                </vs-chip>
            </div>
            <div class="flex flex-wrap items-center">
                <p>Status Device : </p>
                <vs-chip class="my-2 ml-2" v-bind:color="statusDeviceColor">
                    {{statusDeviceText}}
                </vs-chip>
            </div>
            <div class="flex flex-wrap items-center my-2">
                <p>Device Code : {{stateDeviceCode}} </p>
            </div>
            <vs-divider/>
            <p class="mb-2 w-full">Harap memasukkan device code sebelum menghapus device</p>
            <vs-input id="input-device-code" label="Device Code" placeholder="Insert Device Code" v-model="deviceCode" class="w-full my-4" />
            <div id="btn-add-container">
                <vs-button class="btn-add-mapping" id="btn-add-mapping" @click="submitData()" color="primary" type="gradient" :disabled='this.disabled_button'>Submit</vs-button>
            </div>
        </vs-popup>
        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                        >
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-dropdown id="ddl-device" vs-trigger-click class="cursor-pointer">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ filterDevice }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu class="popup-dropdown">
                            <vs-dropdown-item id="ddl-device-all" @click="fetchData(1, 20)">
                                <span>All</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-device-assigned" @click="fetchData(1, 50, true)">
                                <span>Device Assigned</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-device-not-assigned" @click="fetchData(1, 100, false)">
                                <span>Device not Assigned</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="dataTrx"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :floatingFilter="true"
                :pagination="true"
                :paginationPageSize="limit"
                :suppressPaginationPanel="true"
                :enableCellTextSelection="true"
            ></ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage"/>
            
        </vx-card>
    </div>
</template>

<script>
    import {AgGridVue} from "ag-grid-vue";
    import {url} from "@/configs/apiUrl";
    import moment from 'moment'
    import Axios from "@/global/AxiosCall";
    import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
    import StatusProvisionAgridComponent from "../../../components/cell-render-component/StatusProvisionAgridComponent";
    import StatusDeviceAgGridComponent from "../../../components/cell-render-component/StatusDeviceAgGridComponent";
    import ActionTableAgGridComponent from "@/components/cell-render-component/device-report/DetailGridComponent";
    import swal from "sweetalert2";

    export default {
        components: {
            AgGridVue,
        },
        data() {
            return {
                filterDevice: 'All Device',
                searchQuery: "",
                gridOptions: {},
                maxPageNumbers: 7,
                gridApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                },
                columnDefs: [
                    {
                        headerName: "Device Name",
                        field: "name",
                        filter: true,
                        width: 350,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Serial Number",
                        field: "serial_number",
                        width: 400,
                        filter: true,
                        editable:true,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Device Type",
                        field: "device_type_name",
                        filter: true,
                        width: 350,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Device Code",
                        field: "device_code",
                        filter: true,
                        width: 250,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Request Code",
                        field: "request_code",
                        filter: true,
                        width: 250,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Merchant Name",
                        field: "merchant_name",
                        filter: true,
                        width: 350,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Status",
                        field: "status_device",
                        cellRendererFramework: StatusDeviceAgGridComponent,
                        width: 250
                    },
                    {
                        headerName: "Status Provision",
                        field: "status_provision",
                        cellRendererFramework: StatusProvisionAgridComponent,
                        width: 250
                    },
                    {
                        headerName: "Expected Date",
                        field: "expected_date",
                        width: 250,
                        cellRenderer: params => {
                            if (params.value)
                                return moment(params.value).format('YYYY-DD-MM hh:mm:ss')
                            else
                                return '-'
                        }
                    },
                    {
                        headerName: "Provision Date",
                        field: "provision_date",
                        width: 250,
                        cellRenderer: params => {
                            if (params.value)
                                return moment(params.value).format('YYYY-DD-MM hh:mm:ss')
                            else
                                return '-'
                        }
                    },
                    {
                      headerName: "Actions",
                      field: "id",
                      filter: false,
                      editable: false,
                      cellRendererParams: { isConfigure: false, isDetail: true },
                      cellRendererFramework: ActionTableAgGridComponent,
                      width: 150
                    }
                ],
                dataTrx: [],
                dataCount: 0,
                totalPage: 0,
                page: 1,
                limit: 20,
                totalData: 1,
                status: "prvision",
                showPopUp: false,
                deviceCode:"",
                stateDeviceCode : "",
                stateDeviceStatus :"",
                stateDeviceProvisioning : "",
                stateDeviceId : "",
                statusColor: "",
                statusText: "",
                statusDeviceColor: "",
                statusDeviceText: "",
                auditDevice: {
                    user_id: "",
                    session_id: "",
                    user_name: "",
                    menu: "",
                    activity: "",
                    data_before: {},
                    data_after: {},
                },
                disabled_button: true,
            };
        },
        watch: {
            checkData(){
                this.disabled_button = this.checkData;
            },
            checkDevice(){
                this.deviceCode = this.checkDevice;
            }
        },
        computed: {
            currentPage: {
                get() {
                    if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                    else return 1;
                },
                set(val) {
                    this.fetchData(val, this.limit);
                }
            },
            checkData(){
                if(this.deviceCode !== ""){
                    return false
                }else{
                    return true
                }
            },
            checkDevice(){
                if(!this.showPopUp){
                    return ""
                }else{
                    return this.deviceCode
                }
            }
        },
        methods: {
            nullColumnRenderer(params) {
                if (params.value === null)
                    return '-'
                else
                    return params.value
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val);
            },
            fetchData(page, limit, used) {
                this.openLoading();
                let newPage = page;
                if (this.dataCount != 0) {
                    let totalPages = Math.ceil(this.dataCount / limit);
                    if (page > totalPages) {
                        newPage = totalPages;
                    }
                }
                newPage

                let newUrl = url.svd.device.report + "?page=" + page + "&limit=" + limit
                if (used !== undefined)
                    newUrl = url.svd.device.report + "?page=" + page + "&limit=" + limit + '&used=' + used

                Axios.Get(newUrl)
                    .then(resp => {
                        this.$vs.loading.close();
                        this.dataTrx = [];
                        if (resp.data.data.length != 0) {
                            this.totalData = parseInt(resp.data.total)
                            let no = ((page - 1) * limit) + 1;
                            for (let data of resp.data.data) {
                                data.no = no;
                                this.dataTrx.push(data);
                                no++;
                            }

                            this.dataCount = resp.data.total;
                            this.page = page;
                            if (limit >= this.dataCount) {
                                this.limit = this.dataTrx.length;
                            } else {
                                this.limit = limit;
                            }

                            this.gridApi.paginationSetPageSize(this.limit);
                            this.totalPage = resp.data.lastPage;
                        }
                    })
                    .catch(e => {
                        this.$vs.loading.close();
                        console.log(e);
                    });
            },
            openLoading() {
                this.$vs.loading({
                    type: "default"
                });
            },
            unpairRecord(data) {
              swal.fire({
                title: 'Are you sure?',
                text: "Unpair this device",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!'
              }).then((result) => {
                if (result.value) {
                  let url_unpair = url.svd.device.unpair + '/' + data
                  Axios.Put(url_unpair)
                    .then(resp => {
                        if (resp.code==200) {
                            this.$store.dispatch('createAuditTrail', {
                                user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                                session_id: parseInt(localStorage.getItem('sessID')),
                                user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                                menu:      "Device Report",
                                activity: "Unpair Device",
                                data_before: {id: data, value : false},
                                data_after: {id: data, value: result},
                            })
                            this.fetchData(this.page, this.limit)
                            swal.fire(
                                'Unpaired!',
                                'This device has been unpaired',
                                'success'
                            )
                        } else {
                            swal.fire({
                                type: 'error',
                                title: 'Failed!',
                                text: 'This device failed to unpair!'
                            })
                        }
                    })
                    .catch(e => {
                        e
                        swal.fire({
                            type: 'error',
                            title: 'Failed!',
                            text: 'Internal server error!'
                        })
                    });
                }
              })
            },
            configRecord(data){
                this.$router.push({name:'DeviceConfig', query:{id:data}})
            },
            detailRecord(data){
                this.$router.push({name:'DeviceDetail', query:{id:data}})
            },
            deleteRecord(data){
                this.showPopUp = true
                this.stateDeviceCode = data.deviceCode
                this.stateDeviceStatus = data.status
                this.stateDeviceProvisioning = data.isProvisioned
                this.stateDeviceId = data.id

                if (data.isProvisioned !== '' && data.isProvisioned !== null && data.isProvisioned !== undefined) {
                    if (data.isProvisioned === 'not provisioned') {
                        this.statusColor = 'dark'
                        this.statusText = 'Not Provisioned'
                    } else if (data.isProvisioned === 'provisioned') {
                        this.statusColor = 'success'
                        this.statusText = 'Provisioned'
                    }
                }
                else {
                    if (data.isProvisioned === 'asign') {
                        this.statusColor = 'success'
                        this.statusText = 'Assigned'
                    }else {
                        this.statusText = 'Pending'
                    }
                }

                if (data.status !== '' && data.status !== null && data.status !== undefined) {
                    if (data.status === 'not asign') {
                        this.statusDeviceColor = 'dark'
                        this.statusDeviceText = 'Not Asign'
                    } else if (data.status === 'asign') {
                        this.statusDeviceColor = 'success'
                        this.statusDeviceText = 'Asign'
                    }
                }
            },
            submitData(){
                if(this.stateDeviceCode === this.deviceCode){
                     this.showPopUp = false
                     this.$vs.dialog({
                        type:'confirm',
                        color: 'danger',
                        title: `Confirm`,
                        text: `Are you sure deleted this device?`,
                        accept:()=>{
                            this.acceptDelete(this.stateDeviceId)
                        },
                        cancel:()=>{
                            this.deviceCode = ""
                        }
                    })
                }else{
                    this.showPopUp = false
                    this.deviceCode = ""
                    this.$vs.notify({
                        title: "Failed",
                        text: "Device Code is not same!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "danger",
                        position: "top-right"
                    });
                }
            },
            acceptDelete(id){
                this.openLoading();
                Axios.Delete(url.svd.device_request_new.delete+"/"+id)
                .then(resp => {
                    if(resp.code === 200){
                        this.auditDevice = {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "Device Report",
                            activity: "Delete Device",
                            data_before: resp.data,
                            data_after: {}
                        }
                        this.deviceCode = ""
                        this.$store.dispatch('createAuditTrail', this.auditDevice)
                        this.$vs.loading.close();
                        swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Delete Device Success!',
                        })
                        this.fetchData(1, 20);
                    }else{
                        swal.fire({
                            type: 'error',
                            title: 'Failed!',
                            text: 'Failed Delete Device!'
                        })
                        this.deviceCode = ""
                        this.$vs.loading.close();
                    }
                }) .catch(e => {
                    console.log(e);
                    this.$vs.loading.close();
                    this.deviceCode = ""
                    swal.fire({
                        type: 'error',
                        title: 'Failed!',
                        text: 'Failed Delete Device!'
                    })
                });
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridOptions.getRowStyle = function(params) {
                if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
                }
            }
            this.gridOptions.rowHeight = 42;
                
            this.$root.$on("unpair-from-ActionTableAgGridComponent", data => {
                this.unpairRecord(data);
            });
            this.$root.$on("config-from-ActionTableAgGridComponent", data =>{
                this.configRecord(data)
            });
            this.$root.$on("detail-from-ActionTableAgGridComponent", data =>{
                this.detailRecord(data)
            });
            this.$root.$on("delete-device-from-ActionTableAgGridComponent", data =>{
                this.deleteRecord(data)
            });
        }
    };
</script>

<style>
    .popup-dropdown {
        width: 150px;
    }
</style>